module.exports = __webpack_public_path__ + "images/4f241361928a90041b9d189c2b5c1229.png";